export class History {
    constructor(items, maxHistory = Infinity) {
        this.items = items;
        this.maxHistory = maxHistory;
        if (items.length <= 0) {
            throw new Error("History must contain atleast one previous (or initial) state");
        }
    }
    get current() {
        return this.items[0];
    }
    get previous() {
        return this.items[1];
    }
    get length() {
        return this.items.length;
    }
    push(item) {
        this.items.unshift(item);
        if (this.items.length > this.maxHistory) {
            this.items = this.items.slice(0, this.maxHistory);
        }
    }
    pop() {
        return this.items.shift();
    }
    removePrevious() {
        if (this.length > 1) {
            const head = this.pop();
            this.pop();
            this.push(head);
        }
    }
    toArray() {
        return [...this.items];
    }
    map(fn) {
        return this.toArray().map(fn);
    }
}
export class Context {
    constructor(history, options) {
        this.history = history;
        this.options = options;
    }
    get allowUnhandled() {
        return this.options.allowUnhandled;
    }
    get onAsyncEnterExit() {
        return this.options.onAsyncEnterExit;
    }
    get disableLogging() {
        return this.options.disableLogging;
    }
    get customLogger() {
        return this.options.customLogger;
    }
    get currentState() {
        return this.history.current;
    }
}
export function createInitialContext(history = [], options) {
    return new Context(new History(history, (options && options.maxHistory) || Infinity), {
        allowUnhandled: (options && options.allowUnhandled) || false,
        onAsyncEnterExit: (options && options.onAsyncEnterExit) || "warn",
        disableLogging: (options && options.disableLogging) || false,
        customLogger: (options && options.customLogger) || undefined,
    });
}
//# sourceMappingURL=context.js.map